namespace GeniuzPOS.AdvPromo {
    export interface PsPromoTypeForm {
        PmType: Serenity.LookupEditor;
        PPtype: Serenity.IntegerEditor;
        PmTypeDesc: Serenity.StringEditor;
        Condition: Serenity.StringEditor;
    }

    export class PsPromoTypeForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsPromoType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoTypeForm.init)  {
                PsPromoTypeForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;

                Q.initFormType(PsPromoTypeForm, [
                    'PmType', w0,
                    'PPtype', w1,
                    'PmTypeDesc', w2,
                    'Condition', w2
                ]);
            }
        }
    }
}
